<template>
    <div class="flex items-center cursor-pointer">
        <input
            :id="label"
            type="radio"
            :name="name"
            :checked="isChecked"
            :value="value"
            :disabled="disabled"
            @input="$emit('update:modelValue', value);"
            :class="['focus:ring-0 focus:ring-transparent h-4 w-4 border-interactive-6 checked:bg-primary-1 text-primary-1', isChecked && !disabled && 'hover:opacity-50  hover:border-primary-1']"
        />
        <div class="ml-2">
            <label :for="label" class="block text-body-6 font-normal text-default-1"> {{ label }} </label>
        </div>
    </div>
</template>
<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    value: {
        type: String,
    },
    name: {
        type: String,
    },
    disabled: {
        type: Boolean,
        default: false
    },
    selectedValue: {
        type: String,
        required: true,
    }
});

const isChecked = computed(() => {
    return props.value === props.selectedValue;
});
</script>